/**
 * Counted nouns, so a row never reads "1 days".
 *
 * Deliberately dumb: English regular plurals plus an explicit form for the
 * irregular ones. It exists so every "<n> <noun>" in the UI agrees with its
 * number in one place rather than through a ternary copied from row to row.
 *
 * @param count - the number the noun belongs to
 * @param singular - the noun as it reads for exactly one
 * @param pluralForm - the plural, when appending "s" would be wrong
 * @returns the noun alone, for the caller to place after the count
 */
export function plural(count: number, singular: string, pluralForm?: string): string {
  return count === 1 ? singular : (pluralForm ?? `${singular}s`);
}

/** The count and its noun together: `countOf(1, 'day')` → "1 day". */
export function countOf(count: number, singular: string, pluralForm?: string): string {
  return `${count} ${plural(count, singular, pluralForm)}`;
}
